import { HEADER_HEIGHT } from '@/core/constants/layout';

const RESULTS_HEADER_HEIGHT = 50;

export const noSearchResultsStyles = {
	root: (fullHeight: boolean) => ({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
		height: '100%',
		py: 4,
		minHeight: fullHeight
			? {
					sm: 'unset',
					md: `calc(80vh - ${HEADER_HEIGHT}px - ${RESULTS_HEADER_HEIGHT}px)`
				}
			: 'unset'
	}),

	searchIcon: {
		color: 'text.secondary',
		width: '145px',
		height: '145px',
		marginBottom: 3,
		marginTop: 3
	},

	noResultsMain: {
		fontWeight: 700,
		fontSize: '1.2rem'
	},

	selectedFiltersMessage: {
		textAlign: 'center',
		maxWidth: '600px',
		margin: '0 auto'
	},

	alternativeMessage: {
		mt: 2,
		mb: 1
	},

	backButtonContainer: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'row'
	},

	backButton: {
		color: 'primary.main',
		fontSize: '0.875rem'
	},

	ctaContainer: {
		maxWidth: {
			lg: '60%',
			md: '100%'
		}
	}
};
